import createIcon from '../../createIcon';

/**
 * @component @name AccountBalanceWallet
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSA3LjI4VjVDMjAuNSAzLjkgMTkuNiAzIDE4LjUgM0g0LjVDMy4zOSAzIDIuNSAzLjkgMi41IDVWMTlDMi41IDIwLjEgMy4zOSAyMSA0LjUgMjFIMTguNUMxOS42IDIxIDIwLjUgMjAuMSAyMC41IDE5VjE2LjcyQzIxLjA5IDE2LjM3IDIxLjUgMTUuNzQgMjEuNSAxNVY5QzIxLjUgOC4yNiAyMS4wOSA3LjYzIDIwLjUgNy4yOFpNMTkuNSA5VjE1SDEyLjVWOUgxOS41Wk00LjUgMTlWNUgxOC41VjdIMTIuNUMxMS40IDcgMTAuNSA3LjkgMTAuNSA5VjE1QzEwLjUgMTYuMSAxMS40IDE3IDEyLjUgMTdIMTguNVYxOUg0LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUuNSAxMy41QzE2LjMyODQgMTMuNSAxNyAxMi44Mjg0IDE3IDEyQzE3IDExLjE3MTYgMTYuMzI4NCAxMC41IDE1LjUgMTAuNUMxNC42NzE2IDEwLjUgMTQgMTEuMTcxNiAxNCAxMkMxNCAxMi44Mjg0IDE0LjY3MTYgMTMuNSAxNS41IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccountBalanceWallet = createIcon('AccountBalanceWallet', [
  [
    'path',
    {
      d: 'M20.5 7.28V5C20.5 3.9 19.6 3 18.5 3H4.5C3.39 3 2.5 3.9 2.5 5V19C2.5 20.1 3.39 21 4.5 21H18.5C19.6 21 20.5 20.1 20.5 19V16.72C21.09 16.37 21.5 15.74 21.5 15V9C21.5 8.26 21.09 7.63 20.5 7.28ZM19.5 9V15H12.5V9H19.5ZM4.5 19V5H18.5V7H12.5C11.4 7 10.5 7.9 10.5 9V15C10.5 16.1 11.4 17 12.5 17H18.5V19H4.5Z',
      key: '1x3vim',
    },
  ],
  [
    'path',
    {
      d: 'M15.5 13.5C16.3284 13.5 17 12.8284 17 12C17 11.1716 16.3284 10.5 15.5 10.5C14.6716 10.5 14 11.1716 14 12C14 12.8284 14.6716 13.5 15.5 13.5Z',
      key: '3p4wph',
    },
  ],
]);

export default AccountBalanceWallet;
